import { render } from "./TheModalExporter.vue?vue&type=template&id=33d8f2a4"
import script from "./TheModalExporter.vue?vue&type=script&lang=js"
export * from "./TheModalExporter.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__